import { render, staticRenderFns } from "./TemplateStruct.vue?vue&type=template&id=2b066044&"
import script from "./TemplateStruct.vue?vue&type=script&lang=js&"
export * from "./TemplateStruct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports